export default "__VITE_ASSET__DBFt0sGh__"